import React from 'react'

import { CollectionLayoutFragmentFragment } from '../../../../__generated__/graphql/catalog/graphql'
import { SeoMeta } from '../../../../components/SeoMeta'

import { useFilterAugmentedMetadata } from './hooks/useFilterAugmentedMetadata'

export const CollectionMeta: React.FC<{
  collectionView?: Pick<
    CollectionLayoutFragmentFragment,
    'handle' | 'name' | 'noindex' | 'socialDescription' | 'socialImage'
  >
}> = ({ collectionView }) => {
  const { handle, name, noindex, socialDescription, socialImage } = collectionView || {}

  const { filterAugmentedCanonicalUrl, filterAugmentedTitle } = useFilterAugmentedMetadata({
    handle,
    title: name,
  })

  return (
    <SeoMeta
      noindex={noindex ?? undefined}
      canonicalUrl={filterAugmentedCanonicalUrl}
      description={socialDescription ?? undefined}
      image={socialImage ?? undefined}
      title={filterAugmentedTitle}
    />
  )
}
